import { render, staticRenderFns } from "./IconArrowLeftLong.vue?vue&type=template&id=3003cabc"
import script from "./IconArrowLeftLong.vue?vue&type=script&lang=js"
export * from "./IconArrowLeftLong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports